import React from 'react';
import TvComponentContainer from '../../components/tv/containers/TvComponentContainer';
import HeaderTags from '../../common/headerTags/HeaderTags';

const headerTags = {
    title: 'Antena 1 TV', // max 60 char in total, ' | Antena 1' (11 chars) is automatically added by the Headers Tag and is truncated
    meta:
    {
        description: 'Assista ao stream ao vivo da Antena 1! O dia todo o melhor do mundo da música com letra e tradução das músicas, só no Antena 1 TV.',
        keywords: 'Antena 1 TV, live stream, live stream de video, video stream, letra e tradução, ao vivo, streaming, música',
        'og:title': 'Antena 1 TV',
        'og:description': 'Assista ao stream ao vivo da Antena 1! O dia todo o melhor do mundo da música com letra e tradução das músicas, só no Antena 1 TV.',
        'og:image': 'https://a1media.antena1.com.br/image/share/antena1-tv.png',
    },
};

const Tv = () => (
    <div className="pageWrapper tw-container tw-m-auto tw-px-5">
        <HeaderTags title={headerTags.title} meta={headerTags.meta} />
        <TvComponentContainer />
    </div>
);

export default Tv;
